import React from 'react';
import { Resource } from '../../lib/resources';
import ResourceWorkingAvailabilityComponent from '../resources/ResourceAvailability';

interface AvailabilitySectionProps {
  resource: Resource;
  editMode: string | null;
  formData: Partial<Resource>;
  setFormData: (data: Partial<Resource>) => void;
  onSave: (section: string) => void;
  onEdit: (section: string) => void;
  loading?: boolean;
}

export default function AvailabilitySection({
  resource,
}: AvailabilitySectionProps) {
  // Generate a unique instance ID that includes the resource ID
  // This will force the component to completely remount when the resource changes
  const instanceId = `resource_${resource.id}_${Date.now()}`;
  
  console.log(`Rendering AvailabilitySection for resource: ${resource.id} with instance ID: ${instanceId}`);
  
  return (
    <div>
      <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
        <h3 className="text-base font-semibold text-gray-900">Working Hours</h3>
      </div>
      <div className="p-0">
        {/* Key ensures a fresh component instance for each resource */}
        <ResourceWorkingAvailabilityComponent
          key={instanceId}
          resourceId={resource.id}
          businessId={resource.business_id}
        />
      </div>
    </div>
  );
}